import * as React from "react";
import type { SVGProps } from "react";
const SvgPercentageInCircleMulticolor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9} fill="#2871E7" />
    <path
      fill="#fff"
      d="M14.49 12.99c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5ZM14.28 8.28c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41l-6 6c-.2.19-.45.29-.71.29a.996.996 0 0 1-.71-1.7l6-6ZM9.49 7.99c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPercentageInCircleMulticolor;
